module.exports = __webpack_public_path__ + "img/down-arrow.2957a917.svg";